<template>
    <div class="row row-xs">
        <div class="col-lg-8 col-xl-7 mg-t-10">

            <div class="card">
                 <div v-if="revloading" class="text-center">
                    <span  class="spinner-border spinner-border text-danger" role="status" aria-hidden="true"></span>
                    <p class="text-danger">Loading</p>
                </div>
                <template v-else>
                    <div class="card-header pd-y-20 d-md-flex align-items-right justify-content-between" style="right: 0">
                        <h6 class="mg-b-0">Transaction By Date</h6>
                        <ul class="list-inline d-flex mg-t-20 mg-sm-t-10 mg-md-t-0 mg-b-0">
                            <li class="list-inline-item d-flex align-items-center">
                                <span class="d-block wd-10 ht-10 bg-df-1 rounded mg-r-5"></span>
                                <span class="tx-sans tx-uppercase tx-10 tx-medium tx-color-03">Transaction By Date</span>
                            </li>

                        </ul>
                    </div><!-- card-header -->
                    <div class="card-body mb-12 pos-relative pd-0">
                        <div class="pos-absolute t-20 l-20 wd-xl-100p z-index-10">
                            <div class="row">
                                <div class="col-sm-5">
                                    <h3 class="tx-normal tx-rubik tx-spacing--2 mg-b-5">{{ account.totalsum.sum  | toCurrency }}</h3>
                                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-10">Total Account Balance</h6>
                                    <p class="mg-b-0 tx-12 tx-color-03">Total balance for all accounts</p>
                                </div><!-- col -->
                                <div class="col-sm-5 mg-t-20 mg-sm-t-0">
                                    <h3 class="tx-normal tx-rubik tx-spacing--2 mg-b-5">{{ account.totalsum.max | toCurrency  }}</h3>
                                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-10">Max Amount Spent In A Day</h6>
                                    <p class="mg-b-0 tx-12 tx-color-03">Maximum Balance of Account</p>
                                </div><!-- col -->
                            </div><!-- row -->
                        </div>

                        <div class="chart-one">
                            <!--                        <bar-chart style="height: auto; width: 500px;" :data="revenueData" :option="revenueOptions"/>-->
                            <line-chart   style="height: 30vh; width: 100%; margin-top: 17.2vh" class="mt-12"  :data="account.revenueData" :option="revenueOptions"></line-chart>
                        </div><!-- chart-one -->
                    </div><!-- card-body -->
                </template>

            </div><!-- card -->
        </div>
        <div class="col-lg-4 col-xl-5 mg-t-10">
            <div class="card">
                <div v-if="revloading" class="text-center">
                    <span  class="spinner-border spinner-border text-danger" role="status" aria-hidden="true"></span>
                    <p class="text-danger">Loading</p>
                </div>
                <template v-else>
                    <div class="card-header pd-t-20 pd-b-0 bd-b-0">
                        <h6 class="mg-b-5">Account Transactions</h6>
                        <p class="tx-12 tx-color-03 mg-b-0">Number of customers who have active subscription with you.</p>
                    </div><!-- card-header -->
                    <div class="card-body pd-20">
                        <div class="chart-two mg-b-20">
                            <bar-chart style="height: 30vh; width: 100%;" :data="account.retentionData" :option="retentionOptions"></bar-chart>
                        </div><!-- chart-two -->
                        <div class="row">
                            <div class="col-sm">
                                <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-5">{{ account.totalsum.retmax | toCurrency}}</h4>
                                <p class="tx-11 tx-uppercase tx-spacing-1 tx-semibold mg-b-10 tx-primary">Account Max</p>
                                <div class="tx-12 tx-color-03">Account with the maximum of all balances</div>
                            </div><!-- col -->
                            <div class="col-sm mg-t-20 mg-sm-t-0">
                                <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-5">{{ account.totalsum.retmin| toCurrency }}</h4>
                                <p class="tx-11 tx-uppercase tx-spacing-1 tx-semibold mg-b-10 tx-pink">Account Min</p>
                                <div class="tx-12 tx-color-03">Account with the minimum of all balances</div>
                            </div><!-- col -->
                        </div><!-- row -->
                    </div><!-- card-body -->
                </template>

            </div><!-- card -->
        </div>
    </div>
</template>

<script>
    import BarChart from "../chart/BarChart";
    import LineChart from "../chart/LineChart";
    import { mapState } from "vuex";

    export default {
        name: "AccountChart",
        components:{
            LineChart,
            BarChart
        },
        props: ['revenueData', 'loading', 'retentionData', 'sum'],
        data:()=>{
            return{
                revenueOptions: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },


                retentionOptions: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        computed: {
            revloading: function () {
                return JSON.stringify(this.$store.state.account.retentionData) === '{}';
            },
            ...mapState(['account'])
        },
        methods: {},
        mounted() {
        }

    }
</script>

<style scoped>

</style>
